import { jsx, jsxs } from "react/jsx-runtime";
const LoadingSkeleton = ({
  variant = "default",
  lines = 3,
  className = "",
  showAvatar = false,
  showStats = false,
  showActions = false
}) => {
  const baseClasses = "animate-pulse";
  const shimmerClasses = "bg-slate-200/70 dark:bg-slate-700/70 rounded-md";
  const cardClasses = "bg-white dark:bg-slate-900 border border-slate-200/50 dark:border-slate-700/50 rounded-lg shadow-sm";
  if (variant === "default") {
    return /* @__PURE__ */ jsx("div", { className: `space-y-3 ${className} ${baseClasses}`, children: Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-full` }),
      /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-3/4` })
    ] }, index)) });
  }
  if (variant === "card") {
    return /* @__PURE__ */ jsx("div", { className: `${cardClasses} p-6 ${className}`, children: /* @__PURE__ */ jsxs("div", { className: baseClasses, children: [
      showAvatar && /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-4 mb-4", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} w-10 h-10 rounded-full` }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1 space-y-2", children: [
          /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-32` }),
          /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-24` })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "space-y-3", children: Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-full` }, index)) }),
      showStats && /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 gap-4 mt-6 pt-4 border-t border-slate-100 dark:border-slate-800", children: Array.from({ length: 3 }).map((_, index) => /* @__PURE__ */ jsxs("div", { className: "text-center space-y-1", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-5 w-8 mx-auto` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-12 mx-auto` })
      ] }, index)) }),
      showActions && /* @__PURE__ */ jsxs("div", { className: "flex justify-center space-x-3 mt-4", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-8 w-16` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-8 w-16` })
      ] })
    ] }) });
  }
  if (variant === "hero") {
    return /* @__PURE__ */ jsxs("div", { className: `${className}`, children: [
      /* @__PURE__ */ jsx("div", { className: "bg-gradient-to-r from-slate-100 to-slate-200 dark:from-slate-800 dark:to-slate-700 rounded-lg p-8 mb-6", children: /* @__PURE__ */ jsxs("div", { className: `${baseClasses} flex items-center space-x-6`, children: [
        /* @__PURE__ */ jsx("div", { className: "w-20 h-20 bg-white/60 dark:bg-slate-600/60 rounded-xl flex items-center justify-center", children: /* @__PURE__ */ jsx("div", { className: "w-16 h-16 bg-white/80 dark:bg-slate-500/80 rounded-full" }) }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1 space-y-3", children: [
          /* @__PURE__ */ jsx("div", { className: "h-6 w-48 bg-white/80 dark:bg-slate-500/80 rounded" }),
          /* @__PURE__ */ jsx("div", { className: "h-4 w-32 bg-white/60 dark:bg-slate-600/60 rounded" }),
          /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-4", children: [
            /* @__PURE__ */ jsx("div", { className: "h-3 w-24 bg-white/60 dark:bg-slate-600/60 rounded" }),
            /* @__PURE__ */ jsx("div", { className: "h-3 w-20 bg-white/60 dark:bg-slate-600/60 rounded" })
          ] })
        ] }),
        showActions && /* @__PURE__ */ jsxs("div", { className: "flex space-x-2", children: [
          /* @__PURE__ */ jsx("div", { className: "h-8 w-8 bg-white/60 dark:bg-slate-600/60 rounded" }),
          /* @__PURE__ */ jsx("div", { className: "h-8 w-16 bg-white/60 dark:bg-slate-600/60 rounded" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 lg:grid-cols-3 gap-6", children: [
        /* @__PURE__ */ jsx("div", { className: "lg:col-span-2 space-y-4", children: /* @__PURE__ */ jsx("div", { className: `${cardClasses} p-4`, children: /* @__PURE__ */ jsx("div", { className: `${baseClasses} space-y-3`, children: Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-full` }, index)) }) }) }),
        showStats && /* @__PURE__ */ jsx("div", { className: "space-y-4", children: /* @__PURE__ */ jsx("div", { className: `${cardClasses} p-4`, children: /* @__PURE__ */ jsxs("div", { className: `${baseClasses} space-y-4`, children: [
          /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-20` }),
          /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 gap-3", children: Array.from({ length: 4 }).map((_, index) => /* @__PURE__ */ jsxs("div", { className: "text-center space-y-2", children: [
            /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-6 w-8 mx-auto` }),
            /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-2 w-full` })
          ] }, index)) })
        ] }) }) })
      ] })
    ] });
  }
  if (variant === "stats") {
    return /* @__PURE__ */ jsx("div", { className: `${cardClasses} p-4 ${className}`, children: /* @__PURE__ */ jsxs("div", { className: `${baseClasses} space-y-4`, children: [
      /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-24` }),
      /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 md:grid-cols-4 gap-4", children: Array.from({ length: 4 }).map((_, index) => /* @__PURE__ */ jsxs("div", { className: "text-center space-y-2", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-6 w-10 mx-auto` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-16 mx-auto` })
      ] }, index)) })
    ] }) });
  }
  if (variant === "list") {
    return /* @__PURE__ */ jsx("div", { className: `${cardClasses} divide-y divide-slate-100 dark:divide-slate-800 ${className}`, children: Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsx("div", { className: "p-4", children: /* @__PURE__ */ jsxs("div", { className: `${baseClasses} flex items-center space-x-4`, children: [
      showAvatar && /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} w-8 h-8 rounded-full flex-shrink-0` }),
      /* @__PURE__ */ jsxs("div", { className: "flex-1 space-y-2", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-3/4` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-1/2` })
      ] }),
      /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-12` })
    ] }) }, index)) });
  }
  if (variant === "grid") {
    return /* @__PURE__ */ jsx("div", { className: `grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ${className}`, children: Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsx("div", { className: `${cardClasses} p-4`, children: /* @__PURE__ */ jsxs("div", { className: baseClasses, children: [
      /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-20 w-full mb-3` }),
      /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-full mb-2` }),
      /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-2/3` })
    ] }) }, index)) });
  }
  if (variant === "user") {
    return /* @__PURE__ */ jsx("div", { className: `${cardClasses} p-4 ${className}`, children: /* @__PURE__ */ jsxs("div", { className: `${baseClasses} space-y-4`, children: [
      showAvatar && /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-4 mb-4", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} w-12 h-12 rounded-full` }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1 space-y-2", children: [
          /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-32` }),
          /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-24` })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "space-y-3", children: Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-full` }, index)) }),
      showStats && /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 gap-4 mt-6 pt-4 border-t border-slate-100 dark:border-slate-800", children: Array.from({ length: 3 }).map((_, index) => /* @__PURE__ */ jsxs("div", { className: "text-center space-y-1", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-5 w-8 mx-auto` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-12 mx-auto` })
      ] }, index)) }),
      showActions && /* @__PURE__ */ jsxs("div", { className: "flex justify-center space-x-3 mt-4", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-8 w-16` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-8 w-16` })
      ] })
    ] }) });
  }
  if (variant === "actions") {
    return /* @__PURE__ */ jsx("div", { className: `${cardClasses} p-4 ${className}`, children: /* @__PURE__ */ jsxs("div", { className: `${baseClasses} space-y-4`, children: [
      showAvatar && /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-4 mb-4", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} w-10 h-10 rounded-full` }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1 space-y-2", children: [
          /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-4 w-32` }),
          /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-24` })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "space-y-3", children: Array.from({ length: lines }).map((_, index) => /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-3 w-full` }, index)) }),
      showActions && /* @__PURE__ */ jsxs("div", { className: "flex flex-col space-y-2 mt-4", children: [
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-10 w-full` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-10 w-full` }),
        /* @__PURE__ */ jsx("div", { className: `${shimmerClasses} h-10 w-full` })
      ] })
    ] }) });
  }
  if (variant === "page") {
    return /* @__PURE__ */ jsxs("div", { className: `min-h-screen bg-background ${className}`, children: [
      /* @__PURE__ */ jsxs("div", { className: "container mx-auto max-w-[1600px] py-6 px-4 md:px-6 space-y-6", children: [
        /* @__PURE__ */ jsxs("div", { className: "space-y-2.5 animate-pulse", children: [
          /* @__PURE__ */ jsx("div", { className: "h-7 bg-gradient-to-r from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-md w-56 shimmer-effect" }),
          /* @__PURE__ */ jsx("div", { className: "h-3.5 bg-gradient-to-r from-slate-200/50 via-slate-200/30 to-slate-200/50 dark:from-slate-700/50 dark:via-slate-700/30 dark:to-slate-700/50 rounded-md w-80 shimmer-effect", style: { animationDelay: "0.1s" } })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pt-2", children: [1, 2, 3].map((i) => /* @__PURE__ */ jsxs("div", { className: "space-y-3.5 animate-pulse", style: { animationDelay: `${i * 0.1}s` }, children: [
          /* @__PURE__ */ jsx("div", { className: "h-44 bg-gradient-to-br from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-lg shimmer-effect border border-slate-200/30 dark:border-slate-700/30" }),
          /* @__PURE__ */ jsxs("div", { className: "space-y-2 px-1", children: [
            /* @__PURE__ */ jsx("div", { className: "h-3.5 bg-gradient-to-r from-slate-200/50 via-slate-200/30 to-slate-200/50 dark:from-slate-700/50 dark:via-slate-700/30 dark:to-slate-700/50 rounded w-3/4 shimmer-effect" }),
            /* @__PURE__ */ jsx("div", { className: "h-3 bg-gradient-to-r from-slate-200/40 via-slate-200/20 to-slate-200/40 dark:from-slate-700/40 dark:via-slate-700/20 dark:to-slate-700/40 rounded w-1/2 shimmer-effect" })
          ] })
        ] }, i)) }),
        /* @__PURE__ */ jsx("div", { className: "space-y-5 pt-3 animate-pulse", style: { animationDelay: "0.3s" }, children: /* @__PURE__ */ jsx("div", { className: "h-56 bg-gradient-to-br from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-lg shimmer-effect border border-slate-200/30 dark:border-slate-700/30" }) })
      ] }),
      /* @__PURE__ */ jsx("style", { children: `
          @keyframes shimmer-slide {
            0% {
              background-position: -1000px 0;
            }
            100% {
              background-position: 1000px 0;
            }
          }
          .shimmer-effect {
            background-size: 1000px 100%;
            animation: shimmer-slide 2.5s infinite linear;
          }
        ` })
    ] });
  }
  if (variant === "formBuilder") {
    return /* @__PURE__ */ jsxs("div", { className: `container mx-auto px-4 py-6 ${className}`, children: [
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-12 gap-4 animate-pulse", children: [
        /* @__PURE__ */ jsxs("div", { className: "col-span-12 lg:col-span-3 space-y-4", children: [
          /* @__PURE__ */ jsx("div", { className: "h-48 bg-gradient-to-br from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-lg shimmer-effect border border-slate-200/30 dark:border-slate-700/30" }),
          /* @__PURE__ */ jsx("div", { className: "h-64 bg-gradient-to-br from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-lg shimmer-effect border border-slate-200/30 dark:border-slate-700/30" })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "col-span-12 lg:col-span-6 space-y-4", children: /* @__PURE__ */ jsx("div", { className: "h-96 bg-gradient-to-br from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-lg shimmer-effect border border-slate-200/30 dark:border-slate-700/30" }) }),
        /* @__PURE__ */ jsxs("div", { className: "col-span-12 lg:col-span-3 space-y-4", children: [
          /* @__PURE__ */ jsx("div", { className: "h-48 bg-gradient-to-br from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-lg shimmer-effect border border-slate-200/30 dark:border-slate-700/30" }),
          /* @__PURE__ */ jsx("div", { className: "h-64 bg-gradient-to-br from-slate-200/70 via-slate-200/50 to-slate-200/70 dark:from-slate-700/70 dark:via-slate-700/50 dark:to-slate-700/70 rounded-lg shimmer-effect border border-slate-200/30 dark:border-slate-700/30" })
        ] })
      ] }),
      /* @__PURE__ */ jsx("style", { children: `
          @keyframes shimmer-slide {
            0% {
              background-position: -1000px 0;
            }
            100% {
              background-position: 1000px 0;
            }
          }
          .shimmer-effect {
            background-size: 1000px 100%;
            animation: shimmer-slide 2.5s infinite linear;
          }
        ` })
    ] });
  }
  return null;
};
export {
  LoadingSkeleton
};
//# sourceMappingURL=loading-skeleton.js.map
